import _defineProperty from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { equals, getDisplayName, keys, mapValues, some } from '../utils';
/**
 * @deprecated Use `createConnectedStoreAs` instead.
 */

export function connectAs(stores) {
  return function (Component) {
    var _a;

    return _a =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_a, _React$Component);

      function _a() {
        var _this;

        _classCallCheck(this, _a);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_a).apply(this, arguments));
        _this.state = {
          stores: mapValues(stores, function (_) {
            return _.getCurrentSnapshot();
          }),
          subscriptions: keys(stores).map(function (k) {
            return stores[k].onAll().subscribe(function (_ref) {
              var previousValue = _ref.previousValue,
                  value = _ref.value;

              if (equals(previousValue, value)) {
                return false;
              }

              _this.setState(function (state) {
                return {
                  stores: Object.assign({}, state.stores, _defineProperty({}, k, stores[k].getCurrentSnapshot()))
                };
              });
            });
          })
        };
        return _this;
      }

      _createClass(_a, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.state.subscriptions.forEach(function (_) {
            return _.unsubscribe();
          });
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(props, state) {
          var _this2 = this;

          return some(state.stores, function (s, k) {
            return s !== _this2.state.stores[k];
          }) || Object.keys(props).some(function (_) {
            return props[_] !== _this2.props[_];
          });
        }
      }, {
        key: "render",
        value: function render() {
          return React.createElement(Component, Object.assign({}, this.props, this.state.stores));
        }
      }]);

      return _a;
    }(React.Component), _a.displayName = "withStore(".concat(getDisplayName(Component), ")"), _a;
  };
}